import { InjectionToken, APP_INITIALIZER, isDevMode, Injectable, Inject, Directive, Input, HostBinding, ContentChildren, Component, NgModule } from '@angular/core';
import { __awaiter } from 'tslib';
import { interval, merge } from 'rxjs';
import { startWith } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
const NGX_PENDO_SETTINGS_TOKEN = new InjectionToken('ngx-pendo-settings', {
    factory: () => ({ pendoApiKey: '' }),
});
const DEFAULT_PENDO_SCRIPT_ORIGIN = 'https://cdn.pendo.io';
const NGX_PENDO_INITIALIZER_PROVIDER = {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: pendoInitializer,
    deps: [
        NGX_PENDO_SETTINGS_TOKEN,
    ],
};
function pendoInitializer($settings) {
    return () => __awaiter(this, void 0, void 0, function* () {
        if (!$settings.pendoApiKey) {
            if (isDevMode()) {
                console.error('Empty api key for Pendo. Make sure to provide one when initializing NgxPendoModule.');
            }
            return;
        }
        yield new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.async = true;
            script.src = `${$settings.pendoScriptOrigin || DEFAULT_PENDO_SCRIPT_ORIGIN}/agent/static/${$settings.pendoApiKey}/pendo.js`;
            document.head.appendChild(script);
            script.onerror = () => __awaiter(this, void 0, void 0, function* () {
                // The script may have been blocked by an ad blocker
                resolve();
            });
            script.onload = () => __awaiter(this, void 0, void 0, function* () {
                // when enableDebugging should load extra js
                const sub = interval(100).subscribe(() => {
                    if (pendo) {
                        sub.unsubscribe();
                        resolve();
                    }
                });
            });
        });
    });
}

const DEFAULT_PENDO_ID_FORMATTER = pendoId => pendoId;
const ɵ0 = DEFAULT_PENDO_ID_FORMATTER;
class NgxPendoService {
    /**
     * Constructor
     *
     * @param settings IPendoSettings
     */
    constructor(settings) {
        this.pendoIdFormatter = settings.pendoIdFormatter || DEFAULT_PENDO_ID_FORMATTER;
    }
    /**
     * Completely re-initialize the Agent with new options
     *
     * @param visitor IVisitor
     * @param account IAccount
     */
    initialize(visitor, account) {
        pendo.initialize({ visitor, account });
    }
    /**
     * Format Pendo
     *
     * @param ids string[]
     */
    formatPendoId(...ids) {
        return (this.pendoIdFormatter ? ids.map(id => this.pendoIdFormatter(id)) : ids).join('.');
    }
}
NgxPendoService.ɵfac = function NgxPendoService_Factory(t) { return new (t || NgxPendoService)(ɵngcc0.ɵɵinject(NGX_PENDO_SETTINGS_TOKEN)); };
NgxPendoService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgxPendoService, factory: NgxPendoService.ɵfac });
NgxPendoService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [NGX_PENDO_SETTINGS_TOKEN,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxPendoService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [NGX_PENDO_SETTINGS_TOKEN]
            }] }]; }, null); })();

class NgxPendoIdDirective {
    constructor(service) {
        this.service = service;
        this._pendoSections = [];
        // tslint:disable-next-line: no-input-rename
        this.inherit = true;
    }
    get pendoId() {
        return this.service.formatPendoId(...this._pendoSections, this._pendoId);
    }
    set pendoId(value) {
        this._pendoId = value;
    }
    get parent() {
        return this._parent;
    }
    set parent(value) {
        this._parent = value;
        setTimeout(() => {
            this._pendoSections = [];
            let cur = this.inherit ? value : null;
            while (cur) {
                this._pendoSections.unshift(cur.pendoSection);
                cur = cur.inherit ? cur.parent : null;
            }
        });
    }
    get disableInherit() {
        return this.inherit ? undefined : true;
    }
}
NgxPendoIdDirective.ɵfac = function NgxPendoIdDirective_Factory(t) { return new (t || NgxPendoIdDirective)(ɵngcc0.ɵɵdirectiveInject(NgxPendoService)); };
NgxPendoIdDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxPendoIdDirective, selectors: [["", "ngx-pendo-id", ""]], hostVars: 2, hostBindings: function NgxPendoIdDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-pendo-id", ctx.pendoId)("ngx-pendo-disable-inherit", ctx.disableInherit);
    } }, inputs: { inherit: ["ngx-pendo-inherit", "inherit"], pendoId: ["ngx-pendo-id", "pendoId"] } });
NgxPendoIdDirective.ctorParameters = () => [
    { type: NgxPendoService }
];
NgxPendoIdDirective.propDecorators = {
    pendoId: [{ type: Input, args: ['ngx-pendo-id',] }, { type: HostBinding, args: ['attr.data-pendo-id',] }],
    inherit: [{ type: Input, args: ['ngx-pendo-inherit',] }],
    disableInherit: [{ type: HostBinding, args: ['attr.ngx-pendo-disable-inherit',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxPendoIdDirective, [{
        type: Directive,
        args: [{
                selector: '[ngx-pendo-id]'
            }]
    }], function () { return [{ type: NgxPendoService }]; }, { inherit: [{
            type: Input,
            args: ['ngx-pendo-inherit']
        }], pendoId: [{
            type: Input,
            args: ['ngx-pendo-id']
        }, {
            type: HostBinding,
            args: ['attr.data-pendo-id']
        }], disableInherit: [{
            type: HostBinding,
            args: ['attr.ngx-pendo-disable-inherit']
        }] }); })();

class NgxPendoSectionDirective {
    constructor() {
        // tslint:disable-next-line: no-input-rename
        this.inherit = true;
        this.subscriptions = [];
    }
    get disableInherit() {
        return this.inherit ? undefined : true;
    }
    ngAfterContentInit() {
        // set all child parent
        this.subscriptions.push(merge(this.sectionDirectives.changes.pipe(startWith(this.sectionDirectives)), this.idDirectives.changes.pipe(startWith(this.idDirectives))).subscribe((items) => items.forEach(item => {
            if (item !== this) {
                item.parent = this;
            }
        })));
    }
    ngOnChanges(changes) {
        if (changes.pendoSection && !changes.pendoSection.firstChange) {
            this.allIdDirectives.forEach(i => (i.parent = i.parent));
        }
    }
    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
        this.subscriptions = [];
    }
}
NgxPendoSectionDirective.ɵfac = function NgxPendoSectionDirective_Factory(t) { return new (t || NgxPendoSectionDirective)(); };
NgxPendoSectionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxPendoSectionDirective, selectors: [["", "ngx-pendo-section", ""]], contentQueries: function NgxPendoSectionDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgxPendoIdDirective, 4);
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgxPendoSectionDirective, 4);
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgxPendoIdDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.idDirectives = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sectionDirectives = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.allIdDirectives = _t);
    } }, hostVars: 2, hostBindings: function NgxPendoSectionDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("ngx-pendo-disable-inherit", ctx.disableInherit)("ngx-pendo-section", ctx.pendoSection);
    } }, inputs: { inherit: ["ngx-pendo-inherit", "inherit"], pendoSection: ["ngx-pendo-section", "pendoSection"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
NgxPendoSectionDirective.propDecorators = {
    pendoSection: [{ type: Input, args: ['ngx-pendo-section',] }, { type: HostBinding, args: ['attr.ngx-pendo-section',] }],
    inherit: [{ type: Input, args: ['ngx-pendo-inherit',] }],
    disableInherit: [{ type: HostBinding, args: ['attr.ngx-pendo-disable-inherit',] }],
    idDirectives: [{ type: ContentChildren, args: [NgxPendoIdDirective, { descendants: false },] }],
    sectionDirectives: [{ type: ContentChildren, args: [NgxPendoSectionDirective, { descendants: false },] }],
    allIdDirectives: [{ type: ContentChildren, args: [NgxPendoIdDirective, { descendants: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxPendoSectionDirective, [{
        type: Directive,
        args: [{
                selector: '[ngx-pendo-section]'
            }]
    }], function () { return []; }, { inherit: [{
            type: Input,
            args: ['ngx-pendo-inherit']
        }], disableInherit: [{
            type: HostBinding,
            args: ['attr.ngx-pendo-disable-inherit']
        }], pendoSection: [{
            type: Input,
            args: ['ngx-pendo-section']
        }, {
            type: HostBinding,
            args: ['attr.ngx-pendo-section']
        }], idDirectives: [{
            type: ContentChildren,
            args: [NgxPendoIdDirective, { descendants: false }]
        }], sectionDirectives: [{
            type: ContentChildren,
            args: [NgxPendoSectionDirective, { descendants: false }]
        }], allIdDirectives: [{
            type: ContentChildren,
            args: [NgxPendoIdDirective, { descendants: true }]
        }] }); })();

class NgxPendoComponent {
    constructor() { }
    ngOnInit() {
    }
}
NgxPendoComponent.ɵfac = function NgxPendoComponent_Factory(t) { return new (t || NgxPendoComponent)(); };
NgxPendoComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxPendoComponent, selectors: [["lib-ngx-pendo"]], decls: 2, vars: 0, template: function NgxPendoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, " ngx-pendo works! ");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
NgxPendoComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxPendoComponent, [{
        type: Component,
        args: [{
                selector: 'lib-ngx-pendo',
                template: `
    <p>
      ngx-pendo works!
    </p>
  `
            }]
    }], function () { return []; }, null); })();

class NgxPendoModule {
    static forRoot(settings) {
        return {
            ngModule: NgxPendoModule,
            providers: [
                {
                    provide: NGX_PENDO_SETTINGS_TOKEN,
                    useValue: settings
                },
                NGX_PENDO_INITIALIZER_PROVIDER,
                NgxPendoService,
            ],
        };
    }
    static forChild() {
        return {
            ngModule: NgxPendoModule,
            providers: [
                NgxPendoService,
            ],
        };
    }
}
NgxPendoModule.ɵfac = function NgxPendoModule_Factory(t) { return new (t || NgxPendoModule)(); };
NgxPendoModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxPendoModule });
NgxPendoModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxPendoModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NgxPendoComponent,
                    NgxPendoIdDirective,
                    NgxPendoSectionDirective,
                ],
                imports: [],
                exports: [
                    NgxPendoComponent,
                    NgxPendoIdDirective,
                    NgxPendoSectionDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxPendoModule, { declarations: [NgxPendoComponent, NgxPendoIdDirective, NgxPendoSectionDirective], exports: [NgxPendoComponent, NgxPendoIdDirective, NgxPendoSectionDirective] }); })();

/*
 * Public API Surface of ngx-pendo
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NGX_PENDO_INITIALIZER_PROVIDER, NGX_PENDO_SETTINGS_TOKEN, NgxPendoComponent, NgxPendoIdDirective, NgxPendoModule, NgxPendoSectionDirective, NgxPendoService, pendoInitializer, ɵ0 };

